/**
 * Single source of truth for "what state is this published doc actually in".
 *
 * `latestContent` is the object the published-page fetch (_viewContent) returns
 * alongside `contribution`: it reflects the LATEST in-progress version of the doc
 * — the editPublished clone or mod clone when one exists, otherwise the published
 * doc itself. Its `kp_published_status` is the canonical status TplActions gates
 * edit/delete/moderate on (currentStatus), and what the published-page annotation
 * actions must also respect (annotating the OG while a clone is in progress gets
 * overwritten when the clone republishes).
 *
 * Pure helper (takes latestContent in) so both TplActions — which reads
 * latestContent from the query cache — and PublishedPageV3 — which gets it on the
 * contribution query result — can share it without coupling to how it's fetched.
 *
 * @param {{ kp_published_status?: string } | undefined} latestContent
 */
export const getPublishedDocState = (latestContent) => {
  const currentStatus = latestContent?.kp_published_status;
  return {
    currentStatus,
    // clean, safe-to-mutate-in-place: no in-progress edit/mod clone exists.
    isCleanPublished: currentStatus === "published",
    isUnderEdit: currentStatus === "editPublished",
    isUnderModeration:
      currentStatus === "awaitingModeration" ||
      currentStatus === "underModeration",
  };
};
